

export function prepareDataAttributesObject(data) {

    if(null === data || typeof data !== 'object') return {};

    return Object.keys(data).reduce((acc, key) => {
        
        // check if is object
        if(typeof data[key] === 'object') {
            acc[`data-${String(key).toLowerCase()}`] = JSON.stringify(data[key]);
            return acc;
        }

        acc[`data-${String(key).toLowerCase()}`] = data[key];
        return acc;
    },{})
}